import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  fetchPageInitialData,
  PathKey,
  ThunkAPI,
} from '@kanda-libs/ks-frontend-services';
import { type RootState, store } from 'store';
import type { StringIndexedObject } from '@kanda-libs/ks-design-library';

export const reloadInitialData = createAsyncThunk(
  'app/reloadInitialData',
  async (_: undefined, thunkAPI: ThunkAPI) => {
    const state = thunkAPI.getState() as RootState;
    const pathKey = state?.app?.pathKey;

    fetchPageInitialData(
      store,
      pathKey.pages as unknown as StringIndexedObject,
      pathKey as unknown as PathKey<StringIndexedObject>,
      true,
    );
  },
);
